import { ActivityPaymentStatus, ActivityStatus } from './activities/activity.types';
import { EventCustomerRole } from './customers/event-customer.types';
import { EventStatus } from './event.types';
import { PagedFilter, GeoLocation } from '../common/common.types';
import { ActivityType, EventOccasion, EventType, EventVertical } from '../meta/meta.types';
import { Moment } from 'moment';

export class EventPlannerFilter extends PagedFilter {
	statuses?: EventStatus[];
	eventVerticalIds?: number[];
	eventTypeIds?: number[];
	eventOccasionIds?: number[];
	eventBefore?: string | Moment;
	eventAfter?: string | Moment;
}

export class PlannedEvent {
	eventId: number;
	extendedEventId: string;
	legacyBookingId?: number;
	vertical: EventVertical;
	type?: EventType;
	occasion?: EventOccasion;

	name?: string;
	status: EventStatus;

	startsOn?: string | Moment;
	endsOn?: string | Moment;
	isSingleDay?: boolean;
	timezone?: string;

	attendeeTotal?: number;
	currencyCode: string;

	location?: GeoLocation;
	customers?: PlannedEventCustomer[];
	activities?: PlannedEventActivity[];
}

export class PlannedEventCustomer {
	customerId: number;
	role: EventCustomerRole;
	name: string;
	phone: string;
	email: string;
}

export class PlannedEventActivity {
	eventId: number;
	activityId: number;
	activityType: ActivityType;
	providerName?: string;
	productName?: string;
	name?: string;

	status: ActivityStatus;
	paymentStatus?: ActivityPaymentStatus;
	canRequestBooking?: boolean;

	startsOn?: Moment | string;
	endsOn?: Moment | string;
	duration?: number;
	isSingleDay: boolean;
	isAllDay: boolean;
	hasDateError?: boolean;
	timezone?: string;

	attendeeTotal?: number;

	location?: GeoLocation;
	notes: string;
}
